// Import external
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'inArray'
})
export class InArrayPipe implements PipeTransform {

    transform(needle: any, stack: any[]): boolean {
        return !(_.indexOf(stack, needle) === -1);
    }

}
